var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var Freeze = require('../utils/freeze');

module.exports = {
  initialize: function () {
    this.__state = {} as any;
    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  __loadData: function (payload) {
    if (_.isEmpty(payload.data.interestGroups)) {
      return;
    }

    _.each(payload.data.interestGroups, _.bind(function (interestGroup) {
      Freeze.deepFreeze(interestGroup);
      this.__state[interestGroup.id] = interestGroup;
    }, this));

    this.emitChange();
  },

  /**
   * @returns {Object.<InterestGroup>}
   *        Map ID -> InterestGroup for all known InterestGroups.
   */
  getAll: function (): Record<string, InterestGroup> {
    return Freeze.safeReference(this.__state);
  },

  /**
   * @returns {Array.<string>}
   *        IDs of all known InterestGroups.
   */
  getAllIds: function (): string[] {
    return _.keys(this.__state);
  },

  /**
   * @param {string} id
   * @returns {InterestGroup=}
   *        The InterestGroup with the given id, if one exists.
   */
  getById: function (id:string): InterestGroup {
    return Freeze.safeReference(this.__state[id]);
  },
};

